import axios from "axios";

export function getEventCategoryList(co) {
  const config = {
    params: co,
  };
  return axios.get(
    process.env.VUE_APP_API_URL + "EventCategory/getlist",
    config
  );
}

export function postEventCategory(data) {
  return axios.post(process.env.VUE_APP_API_URL + "EventCategory/add", data);
}

export function updateEventCategory(data) {
  return axios.put(process.env.VUE_APP_API_URL + "EventCategory/update", data);
}

export function deleteEventCategory(eventCategoryId) {
  const config = {
    params: {
      eventCategoryId: eventCategoryId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "EventCategory/deleted",
    config
  );
}
